"use client";
import React, { useState, useEffect, useRef } from "react";
import {
  createConversation,
  listConversations,
  updateConversation,
  closeConversation,
} from "@/app/services/conversationService";

import ConversationList from "./ConversationList";
import Modal from "../Elements/Modal";
import ConversationForm from "./ConversationForm";
import { useUser } from "@/app/context/UserContext";
import { getCookie } from "@/app/helpers/cookies";
import { Conversation } from "@/app/models/interfaceConversation";
import { getcurrentUser } from "@/app/helpers/functions";

export interface ConversationManagerRef {
  handleAdd: () => void;
}

const ConversationManager = React.forwardRef<ConversationManagerRef>((props, ref) => {
  const { user, setUser,userProject,
    listConversation, setListConversation,
    listConversationLoading,setListConversationLoading,
    currentConversation,setCurrentConversation,
    changeConversation,setChangeConversation,
    accessType
   } = useUser();

  const [modalOpen, setModalOpen] = useState(false);
  const [editingConv, setEditingConv] = useState<any | null>(null);

  const fetchConversations = async () => {
    setListConversationLoading(true);
    try {
      const res = await listConversations({
        user_id: getcurrentUser(accessType, userProject, user),
        project_id: userProject?.project?.id ?? "",
        company_code: userProject?.project?.company_code ?? "",
      }, user, setUser);
      setListConversation(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      console.error(e);
    } finally {
      setListConversationLoading(false);
    }
  };

  //useEffect(() => {
  //  fetchConversations();
  //}, []);
 
  const handleClose = async (conv: Conversation) => {
    
    if(currentConversation?.conversation_id == conv.conversation_id ){
       setCurrentConversation(null);
        setChangeConversation(true);
    }
    await closeConversation({
      project_id: conv.project_id,
      user_id: conv.user_id,
      conversation_id: conv.conversation_id,
    }, user, setUser);
    await fetchConversations();
    
  };

  React.useImperativeHandle(ref, () => ({
    handleAdd: () => {
      setEditingConv(null);
      setModalOpen(true);
    },
  }));

  return (
    <div className="">
      {listConversationLoading ? (
        <p>Cargando conversaciones...</p>
      ) : (
        <ConversationList
          conversations={listConversation}
          onUpdate={(conv) => {
            setEditingConv(conv);
            setModalOpen(true);
          }}
          onClose={handleClose}
        />
      )}
        <Modal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
        >
          <ConversationForm
            onClose={() => setModalOpen(false)}
            onUpdateList={fetchConversations}
            editingConv={editingConv} 
            /> 
        </Modal>
    </div>
  );
});

ConversationManager.displayName = "ConversationManager";
export default ConversationManager;
